export function isPatchable(object) {
    if (!object) {
        return false;
    }
    return !!object.patch;
}
export function patchContainsChanges(patch, model, context) {
    const patched = model.patch(patch);
    return JSON.stringify(patched.encode(context)) != JSON.stringify(model.encode(context));
}
//# sourceMappingURL=Patchable.js.map